import CMS from "./CMS.js";

// A type's view URL can outlive its detail page (for example /location/{id}).
// Check the website's configured pages before offering that fallback navigation.
export function hasCmsItemViewPage(item, website) {
    const link = item?.getViewLink?.();
    if (!link || !website?.pages) {
        return false;
    }
    const permalink = CMS.parseRoute(link).permalink || `/`;
    return website.pages.some(page => {
        const aliases = typeof page.permalink === `string`
            ? [page.permalink]
            : [page.permalink?.en, page.permalink?.fr, page.permalink?.default];
        return aliases.includes(permalink);
    });
}

export function isUnavailableCmsItemLink(item, link, website) {
    if (!item?.getViewLink || !link || item.mapItems?.some(point => point.visibility !== `never`)) {
        return false;
    }
    return link === item.getViewLink() && !hasCmsItemViewPage(item, website);
}
